/**
 * Un negocio SIN suscripción no es un error: es un estado.
 *
 * `GET /api/v1/business/billing` responde **404** con
 * `{"error":{"code":"NOT_FOUND","context":"el business … no tiene
 * suscripción"}}`. Medido contra dev el 2026-09-12.
 *
 * Colapsar eso en "ocurrió un error" sería el bicho que el CLAUDE.md de este
 * repo ya nombra: un rechazo del dominio y una caída se ven igual desde el
 * `catch`, y la pantalla terminaría diciéndole "reintentá" a alguien que lo que
 * necesita leer es "este negocio no tiene una suscripción".
 *
 * ⚠️ **El 404 solo no alcanza para decidir.** Una ruta que no existe también da
 * 404 —ese mismo endpoint daba 404 de ruta hasta que trd-bff#257 se desplegó, el
 * 2026-09-11— pero con el `Cannot GET …` de NestJS y sin `error.code`. Por eso
 * se exige **además** el código del dominio: si mañana el BFF se cae o alguien
 * renombra la ruta, esto tiene que decir "error", no "no tenés suscripción".
 *
 * Vive en su propio módulo —y no al lado del hook— para poder testearlo sin
 * arrastrar `IpcRest`, que en el entorno de tests no resuelve.
 */
export function esSinSuscripcion(error: unknown): boolean {
  const e = error as { status?: number; response?: { data?: any } };
  if (e?.status !== 404) return false;
  return e?.response?.data?.error?.code === "NOT_FOUND";
}
